import type { PuzzlePack } from 'client/types/PuzzlePack'
import { klubbleAPI, type ApiResult } from './common'

export const fetchPuzzlePackContent = async (puzzlePackId: number, abortController?: AbortController) => {
  try {
    const res = await klubbleAPI.get<ApiResult<PuzzlePack>>(`Puzzle/packs/${puzzlePackId}`, {
      signal: abortController?.signal,
    })
    if (res?.status === 200) {
      return res.data.data
    }
    throw new Error(`${res.config.url} did not return successfully`)
  } catch (e) {
    throw new Error(`Error fetching puzzle pack content: ${e.message}`)
  }
}
